<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0 class="white">
      <Document />
    </v-container>
  </layout>
</template>

<script>
import Document from "../components/documentation/MainDocumentation"
import LeftBarLayout from '../layouts/LeftBarLayout.vue'

export default {
  name: 'Documentation',
  components: { layout: LeftBarLayout, Document },
  metaInfo: { title: "Facilita Pay" }
}

</script>



// WEBPACK FOOTER //
// src/pages/DynamicDocumentation.vue